interface IColorsType {
  [color: string]: string;
}

export const colors: IColorsType = {
  primary: '#54aa8b',
  primaryDark: '#499579',
  secondary: '#f8fafd',
  tertiary: '#f0f3f6',
  border: '#E0E4EC',
  black: '#3a3d42',
  white: '#ffffff',
  background: '#FCFDFD',
  blue: '#4fa7d9',
  yellow: '#e3be3c',
  red: '#D9684F',
  text: '#505050',
  textLight: 'rgba(80, 80, 80, 0.5)',
  textGray: '#7e8da5',
  textLink: '#0000ff',
};
